import React, { memo, useEffect, useRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import SnackbarContent from "@material-ui/core/SnackbarContent";

const useStyles = makeStyles((theme) => ({
  snackbarContent: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "0.7rem",
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  messageIcon: {
    marginRight: theme.spacing(0.5),
  },
}));

function IconGuideSnackbar({ open, onClose }) {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const snackbarKeyRef = useRef(null);

  useEffect(() => {
    if (open && !snackbarKeyRef.current) {
      const key = enqueueSnackbar(
        "アイコンをタップすると詳細画面が表示されます",
        {
          autoHideDuration: 4000,
          content: (snackbarKey) => (
            <SnackbarContent
              className={classes.snackbarContent}
              message={
                <span className={classes.message}>
                  <ErrorOutlineIcon
                    className={classes.messageIcon}
                    fontSize="small"
                  />
                  アイコンをタップすると詳細画面が表示されます
                </span>
              }
              action={
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => closeSnackbar(snackbarKey)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            />
          ),
          onClose: () => {
            snackbarKeyRef.current = null;
            onClose();
          },
        }
      );
      snackbarKeyRef.current = key;
    }

    if (!open && snackbarKeyRef.current) {
      closeSnackbar(snackbarKeyRef.current);
      snackbarKeyRef.current = null;
    }
  }, [open, enqueueSnackbar, closeSnackbar, classes.snackbarContent, classes.message, classes.messageIcon, onClose]);

  return null;
}

export default memo(IconGuideSnackbar);
